<template>
    <div class="machinery-num-area-count">
        <div ref="bar-line" class="machinery-num-area-count--bar" v-auto-size />
    </div>
</template>
<script>
import * as largeScreenAPI from '@/api/large-screen'
import { getRelativelySize } from '@/utils/size'
import { chartFormat, arrayMaxValue } from '@/utils/index'

export default {
    data() {
        return {
            barLineInstance: null
        }
    },
    destroyed() {
        if (this.barLineInstance) this.barLineInstance.dispose()
    },
    mounted() {
        if (this.barLineInstance) this.barLineInstance.dispose()
        this.init()
    },
    methods: {
        init() {
            this.barLineInstance = echarts.init(this.$refs['bar-line'])
            this.setOption()
        },
        async setOption() {
            const { getOption } = this

            const currScreenType = JSON.parse(
                sessionStorage.getItem('currScreenType')
            )
            const response = await largeScreenAPI.getMachineryAndAreaCount(
                currScreenType.locId
            )
            if (response.data.length) {
                const { valueAxis, series, subSeries } = chartFormat(
                    response.data
                )
                this.barLineInstance.setOption(
                    getOption({ valueAxis, series, subSeries })
                )
            }
        },
        getOption(data) {
            const valueAxis = data.valueAxis
            const series = data.series
            const subSeries = data.subSeries
            const barLineUnit = ['亩', '台']
            const barTopColor = ['#3F98DF', '#FF8914']
            const barBottomColor = [
                'rgba(62, 105, 248, 0.1)',
                'rgba(0, 255, 221, 0.1)'
            ]

            const options = {
                grid: {
                    left: '2.5%',
                    right: '2%',
                    top: getRelativelySize(35),
                    bottom: '5%',
                    containLabel: true
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: function(params) {
                        const tooltopSplit = params.map((item, index) => {
                            return `${
                                !index ? item.name : ''
                            }<br /><span style="display: inline-block; width: 10px; height: 10px; margin-right: 5px; border-radius: 50%; background-color: ${
                                barTopColor[item.seriesIndex]
                            };"></span>${
                                item.seriesName
                            }：<span style="color: #f9b236;">${Math.floor(
                                parseFloat(Number(item.value)) * 100
                            ) / 100}</span> <span style="font-size: 12px;">${
                                barLineUnit[item.seriesIndex]
                            }</span>`
                        })
                        // 数组大于 1 时，join 解析会产生逗号
                        return tooltopSplit.join().replace(/,/g, '')
                    },
                    padding: [
                        getRelativelySize(8),
                        getRelativelySize(18),
                        getRelativelySize(8),
                        getRelativelySize(18)
                    ],
                    axisPointer: {
                        lineStyle: {
                            color: 'rgba(151,152,149,.6)'
                        }
                    },
                    backgroundColor: 'rgba(30,31,46,0.80)',
                    borderWidth: getRelativelySize(1),
                    borderColor: 'rgba(15,128,252,0.22)',
                    extraCssText: 'box-shadow: 0 0 8px 2px rgba(0,57,119,0.50)'
                },
                color: ['#3F98DF', '#FF8914'],
                legend: {
                    selectedMode: false,
                    right: getRelativelySize(150),
                    top: getRelativelySize(2),
                    data: ['作业面积', '农机数量'],
                    itemWidth: 12,
                    itemHeight: 12,
                    itemGap: 30,
                    icon: 'rect',
                    textStyle: {
                        fontSize: getRelativelySize(14),
                        color: '#fff',
                        padding: [0, 0, -2, 0]
                    }
                },
                xAxis: {
                    data: valueAxis,
                    axisLabel: {
                        textStyle: {
                            color: '#fff',
                            fontSize: getRelativelySize(12)
                        },
                        formatter: function(params) {
                            const maxLength = 3
                            if (params && params.length >= maxLength) {
                                return params.substring(0, maxLength - 1)
                            } else {
                                return params
                            }
                        }
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(255,255,255,0.3)'
                        }
                    },
                    axisTick: {
                        show: false
                    }
                },
                yAxis: [
                    {
                        name: '作业面积',
                        nameGap: 15,
                        min: 0,
                        max: Math.ceil(arrayMaxValue(series)),
                        nameTextStyle: {
                            color: '#fff',
                            fontSize: getRelativelySize(12),
                            padding: [0, getRelativelySize(48), 0, 0]
                        },
                        axisLabel: {
                            color: '#fff',
                            textStyle: {
                                fontSize: getRelativelySize(12)
                            }
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(255,255,255,0.3)'
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        }
                    },
                    {
                        name: '农机数量',
                        position: 'right',
                        nameGap: 15,
                        // min: 0,
                        // max: Math.ceil(arrayMaxValue(subSeries)),
                        nameTextStyle: {
                            color: '#fff',
                            fontSize: getRelativelySize(12),
                            padding: [0, 0, 0, getRelativelySize(40)]
                        },
                        axisLabel: {
                            color: '#fff',
                            textStyle: {
                                fontSize: getRelativelySize(12)
                            }
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(255,255,255,0.3)'
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(255,255,255,0.3)'
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '作业面积',
                        type: 'bar',
                        data: series,
                        barWidth: '24px',
                        itemStyle: {
                            normal: {
                                color: function() {
                                    return new echarts.graphic.LinearGradient(
                                        0,
                                        0,
                                        0,
                                        1,
                                        [
                                            {
                                                offset: 0,
                                                color: barTopColor[0]
                                            },
                                            {
                                                offset: 1,
                                                color: barBottomColor[0]
                                            }
                                        ]
                                    )
                                }
                            }
                        }
                    },
                    {
                        name: '农机数量',
                        type: 'line',
                        symbol: 'circle',
                        symbolSize: [7, 7],
                        yAxisIndex: 1,
                        data: subSeries,
                        itemStyle: {
                            normal: {
                                color: barTopColor[1]
                            }
                        }
                    }
                ]
            }

            return options
        }
    }
}
</script>
<style lang="scss" scoped>
.machinery-num-area-count {
    width: 100%;
    height: 100%;
    &--bar {
        width: 100%;
        height: 100%;
    }
}
</style>
